<template>
    <div class="newsSecondPageWarp">
        <div class="menubox">
            <NavMenu/>
        </div>
        <div style="background: rgba(68, 141, 247, 0.08);">
            <div class="crumbsBox">
                <div>
                    您当前所在位置：{{currentMenu}}-{{tabactiveTitle}}
                </div>
            </div>
        </div>
        <div class="contentWarp">
            <div class="tabsWarp">
                <router-link v-for="(item,index) in tabsList" :key="index" class="tabItemBox"  active-class="nav-link" :to="item.url" @click.native="jump(item)">
                    <span :class="tabactiveTitle==item.name?'activetext':'text'">{{item.name}}</span>
                </router-link>
            </div>
            <div class="componentBox">
                <router-view />
            </div>
        </div>
        <div class="footerbox">
            <Footer/>
        </div>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer
    },
    data() {
        return {
            srcUrl: srcUrl,
            tabsList: [
                { name: '协会简介', url: "/association-profile/introduct" },
                // { name: '历任会长', url: "/association-profile/past-presidents" },
                { name: '协会领导', url: "/association-profile/association-leader" },
                { name: '组织机构', url: "/association-profile/organization" },
                { name: '协会章程', url: "/association-profile/association-charter" },
                { name: '服务目录', url: "/association-profile/service-catalog" },
            ],
            tabactiveTitle: '协会简介',
            currentMenu: sessionStorage.getItem('clickMenu')

        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                this.tabactiveTitle = val.meta.title
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
    },
    methods: {
        jump(item) {
            this.tabactiveTitle = item.name;
        },
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.newsSecondPageWarp {
	width: 100%;
	.menubox {
		width: 100%;
	}
	.crumbsBox {
		width: 1200px;
		margin: 0 auto;
		// width: 100%;
		// background: rgba(68, 141, 247, 0.08);
		padding: 19px 0 19px 0px;
		color: #448df7;
	}
	.topimgbox {
		width: 100%;
		height: 405px;
	}
	.contentWarp {
		width: 1200px;
		// min-height: 1000px;
		margin: 0 auto;
		.componentBox {
			margin: 0px 0 50px 0;
		}
	}
    .tabsWarp{
        padding-left: 75px;
         .tabItemBox{
            margin-right: 110px;
        }
    }
   
}
</style>


